// @ vendors
const React = require('react');
require('./hireCardOpenCreditStepINEDIR.scss');

// // @ helpers
const { FormattedText } = require('core/i18n').i18n;

import { Documentation } from "./documentation/Documentation"
import { LoadingSection } from "commonsComponents/loadingSection"

export const HireCardOpenCreditStepINEDIR = ({
    precontractualLabel,
    onAcceptAllDocument,
    allDocumentRead,
    initialDocumentList,
    onSavedocumentAcceptance,
    saveDocumentList,
    checkRadioButtonIneDir,
}) => {
    const handleSabeDocumentAcceptance = ({ dmsDocumentType }) => {
        onSavedocumentAcceptance({ documentType: dmsDocumentType })
    }

    if (initialDocumentList.size < 2) {
        return (
            <LoadingSection />
        )
    }

    return (
        <>
            <div className="mortgage-request-holder-confirmation__title">
                <FormattedText value="hireCardCreditCardINEDIR-titlePage" />
            </div>
            <div className="mortgage-request-holder-confirmation__subtitle">
                <FormattedText value="hireCardCreditCardINEDIR-subtitlePage" />
                <Documentation
                    initialDocumentsList={initialDocumentList}
                    onSaveDocumentAcceptance={handleSabeDocumentAcceptance}
                    precontractualLabel={precontractualLabel}
                    onAcceptAllDocument={onAcceptAllDocument}
                    allDocumentRead={allDocumentRead}
                    saveDocumentList={saveDocumentList}
                    checkRadioButtonIneDir={checkRadioButtonIneDir}
                />
            </div>
        </>
    )
}
